import { IDataChangePassword } from './data';
import { API } from '@/services/typings';
import { request } from '@umijs/max';
export const changePassword = async (data: IDataChangePassword) => {
  const res = await request<API.DataResponse<IDataChangePassword>>('v1/cms/admin/change-password', {
    method: 'PUT',
    data,
  });
  return res;
};
